import * as React from "react";

const IconSortOrder: React.FC = () => {
    return <svg xmlns="http://www.w3.org/2000/svg" width="8" height="11" viewBox="0 0 8 11" fill="currentColor"><path fill="currentColor" d="M0.75,3.7078 Z M0,4.5 L0.75,4.5 L6.75,4.5 L7.5,4.5 L7.5,3.75 L7.5,3.375 L3.75,0 L0,3.375 L0,3.75 L0,4.5 Z M0.75,6.7922 Z M0,6 L0,6.75 L0,7.125 L3.75,10.5 L7.5,7.125 L7.5,6.75 L7.5,6 L6.75,6 L0.75,6 L0,6 Z"  transform="translate(0 .25)"/></svg>;
};

export default React.memo(IconSortOrder);
